import React from "react";

const Steps = () => {
  return (
    <section className="py-8 sm:py-10 lg:py-16 sm:pb-36 pb-32 bg-[#fff]">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-24 sm:mb-16 md:mb-32 lg:mb-36">
          <h2 className="text-xl md:text-3xl lg:text-4xl font-extrabold text-[#000300] mb-2">
            Your Investment Journey
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-[#000300] max-w-xs sm:max-w-xl md:max-w-2xl mx-auto">
            Start growing your wealth in just 4 simple steps
          </p>
        </div>

        {/* Circular Stepper - Professionally Aligned */}
        <div className="relative mx-auto aspect-square w-full max-w-[220px] xs:max-w-[260px] sm:max-w-[320px] md:max-w-[380px] lg:max-w-[440px] xl:max-w-[500px]">
          {/* Dashed Circle Path */}
          <svg className="absolute w-full h-full" viewBox="0 0 100 100">
            <path
              d="M 50 10 A 40 40 0 1 1 50 90 A 40 40 0 1 1 50 10"
              fill="none"
              stroke="#E5E7EB"
              strokeWidth="1.5"
              strokeDasharray="4,4"
            />
          </svg>

          {/* Rotating Arrow in Center */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 rounded-full bg-white shadow-md flex items-center justify-center animate-spin-slow">
              <svg
                className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 text-indigo-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 5l7 7-7 7M5 5l7 7-7 7"
                />
              </svg>
            </div>
          </div>

          {/* Step Cards - Perfectly Positioned */}
          {[
            {
              id: 1,
              label: "Choose Plan",
              desc: "Select investment",
              position: "top-0 left-1/2 -translate-x-1/2 -translate-y-1/2",
              bg: "from-gray-500 to-black",
              hover: "hover:-translate-y-1",
            },
            {
              id: 2,
              label: "Make Deposit",
              desc: "Fund account",
              position: "top-1/2 right-0 translate-x-1/2 -translate-y-1/2",
              bg: "from-blue-900 to-gray-900",
              hover: "hover:translate-x-1",
            },
            {
              id: 3,
              label: "Invest & Earn",
              desc: "Watch growth",
              position: "bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2",
              bg: "from-orange-800 to-black",
              hover: "hover:translate-y-1",
            },
            {
              id: 4,
              label: "Withdraw Profits",
              desc: "Cash out",
              position: "top-1/2 left-0 -translate-x-1/2 -translate-y-1/2",
              bg: "from-green-900 to-black",
              hover: "hover:-translate-x-1",
            },
          ].map(({ id, label, desc, position, bg, hover }) => (
            <div
              key={id}
              className={`absolute ${position} w-[6rem] xs:w-[5.5rem] sm:w-[6.5rem] md:w-[7.5rem] lg:w-[8.5rem] xl:w-[9.5rem]`}
            >
              <div
                className={`bg-white p-1.5 sm:p-2 md:p-2.5 lg:p-3 rounded-lg shadow-sm border border-gray-100 text-center transition-all duration-300 ${hover} hover:shadow-md`}
              >
                <div
                  className={`w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 lg:w-9 lg:h-9 xl:w-10 xl:h-10 bg-gradient-to-r ${bg} rounded-full flex items-center justify-center mx-auto mb-1 sm:mb-1.5 md:mb-2`}
                >
                  <span className="text-white text-[10px] sm:text-xs md:text-sm font-medium">
                    {id}
                  </span>
                </div>
                <h3 className="text-[10px] xs:text-xs sm:text-sm md:text-base font-semibold text-gray-800 leading-tight">
                  {label}
                </h3>
                <p className="text-[8px] xs:text-[10px] sm:text-xs md:text-sm text-gray-500 mt-0.5 sm:mt-1">
                  {desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Steps;